// extracted by mini-css-extract-plugin
export default {"page":"homePage_page__Qa8Te","tagForm":"homePage_tagForm__SQHic","five":"homePage_five__Xq935"};